declare global {
	interface Window {
		analytics: {
			load: (
				key: string,
				options?: { integrations: Record<string, boolean> }
			) => void
			track: (title: string, payload: Record<string, unknown>) => void
			identify: (userId: string, payload: Record<string, unknown>) => void
		}
	}
}

export default function useAnalytics() {
	const track = (title: string, payload?: Record<string, unknown>) => {
		window.analytics.track(title, {
			product: 'quick_canvas',
			...payload,
		})
	}
	const identify = (userId: string, payload?: Record<string, unknown>) => {
		window.analytics.identify(userId, {
			...payload,
		})
	}
	return {
		track,
		identify,
	}
}
